import { useCallback, useEffect, useState } from 'react';
import { callAuthAPI } from 'react-morel-auth';

export const useRoles = () => {
  const [roles, setRoles] = useState<Array<string>>([]);
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [errorPermissions, setErrorPermissions] = useState(null);

  const retrieveRoles = useCallback(() => {
    setLoadingPermissions(true);

    callAuthAPI('/security/roles', '', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response: { [key: string]: Array<string> }) => {
        setRoles(Object.keys(response));
      })
      .catch(error => {
        setErrorPermissions(error);
      })
      .finally(() => setLoadingPermissions(false));
  }, []);

  useEffect(() => {
    let timeout: any;
    let cancel = false;
    if (!cancel) {
      setLoadingPermissions(true);
      retrieveRoles();
    }

    return () => {
      clearTimeout(timeout);
      cancel = true;
      setLoadingPermissions(false);
    };
  }, [retrieveRoles]);

  return {
    roles,
    loadingPermissions,
    errorPermissions,
  };
};
